var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon06(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.19 54.02C75.11 63.97 78.07 72.15 75.11 75.11C72.15 78.07 63.97 75.11 54.02 68.19C51.87 80.12 48.19 88 44 88C39.81 88 36.12 80.12 33.98 68.19C24.03 75.11 15.85 78.07 12.89 75.11C9.93 72.15 12.89 63.97 19.81 54.02C7.88 51.88 0 48.19 0 44C0 39.81 7.88 36.12 19.81 33.98C12.89 24.03 9.93 15.85 12.89 12.89C15.85 9.93 24.03 12.89 33.98 19.81C36.12 7.88 39.81 0 44 0C48.19 0 51.88 7.88 54.02 19.81C63.97 12.89 72.15 9.93 75.11 12.89C78.07 15.85 75.11 24.03 68.19 33.98C80.12 36.13 88 39.81 88 44C88 48.19 80.12 51.88 68.19 54.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon06);
export default __webpack_public_path__ + "static/media/icon_06.53e3b853245d966d7adfeb1262538583.svg";
export { ForwardRef as ReactComponent };